exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hero {\n  margin-top: 30px;\n}\n\n.hero-body {\n  background-color: rgba(48, 48, 48, 0.1);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/register/register.component.css
// module id = ../../../../../src/app/components/register/register.component.css
// module chunks = main